import { useEffect, useRef, useState } from "react";
import "./Styles/Dialogue.css";

let timeout = null;

const Dialogue = (props) => {
  const [isVisible, setIsVisible] = useState(false);
  const dialogueContainer = useRef(null);
  useEffect(() => {
    if(timeout) {
      clearTimeout(timeout);
    }

    if (props.dialogue === "") return;
    setIsVisible(true);
    timeout = setTimeout(() => {
      setIsVisible(false);
      props.setDialogue("");
    }, 4000);
    return () => {
      clearTimeout(timeout);
    };
  }, [props.dialogue]);

useEffect(() => {
  console.log({isVisible})
}, [isVisible])

useEffect(() => {
  const handleForceHide= () => {
    setIsVisible(false); 
  };

  const domNode = dialogueContainer.current;
  if (domNode) {
    domNode.addEventListener('hide', handleForceHide);
  }

  return () => {
    if (domNode) {
      domNode.removeEventListener('hide', handleForceHide);
    }
  };
}, []);

  return (
    <>
      <div ref={dialogueContainer} className={`dialogue-container ${isVisible ? "visible" : "hidden"}`}>
        <p className="dialogue-box">{props.dialogue}</p>
      </div>
    </>
  );
};

export default Dialogue;

/**
    https://codepen.io/pompyproductions/pen/yLjRjGG type-effect
  };
 */
